import { render, staticRenderFns } from "./DocumentCustomerPreview.vue?vue&type=template&id=51b2bdac"
import script from "./DocumentCustomerPreview.vue?vue&type=script&lang=js"
export * from "./DocumentCustomerPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports